<template>
  <div class="mx-auto flex w-full max-w-[1140px] flex-col gap-6 px-4 py-[70px]">
    <router-link to="/" class="text-base text-[#3a4250]">← 목록으로</router-link>
    <template v-if="item">
      <h1 class="text-3xl font-bold leading-[1.5] text-[#202632]">{{ item.title }}</h1>
      <div class="flex items-start gap-4 text-lg text-[#3a4250]">
        <p>{{ item.source }}</p>
        <p>{{ item.date }}</p>
      </div>
    </template>
    <p v-else class="text-lg text-[#3a4250]">해당 컬럼을 찾을 수 없습니다.</p>
  </div>
</template>

<script>
import { columns } from '@/data/home'

export default {
  name: 'ColumnDetailView',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    item() {
      return columns.find((c) => c.id === this.id)
    },
  },
}
</script>
